{
  "cycle.entite.anomalies_contexte_corrections": "Defect context corrections",
  "v6.anomalies.annuler_vers_fiche": "Cancel",
  "v6.anomalies.annuler_vers_liste": "Cancel",
  "v6.anomalies.anomalie_absente": "No defect is designated: open this dialog from a defect.",
  "v6.anomalies.champ.cible_source": "Source target",
  "v6.anomalies.champ.environnement": "Environment",
  "v6.anomalies.champ.version": "Version",
  "v6.anomalies.code.ACCESS_DENIED": "You must be an active member of the project for this action.",
  "v6.anomalies.code.DEFECT_SCOPE_MISMATCH": "The version, environment or case does not belong to this project.",
  "v6.anomalies.code.DEFECT_STATE_CONFLICT": "The defect changed state or is closed: reload it before acting.",
  "v6.anomalies.code.DEFECT_TRANSITION_FORBIDDEN": "This transition is not allowed from the current state.",
  "v6.anomalies.code.DEFECT_TRIAGE_REQUIRED": "Classify the failure first: triage the defect.",
  "v6.anomalies.code.DROIT_NON_TENU": "You do not hold the right needed for this action.",
  "v6.anomalies.code.NOT_FOUND": "This defect cannot be found in this project.",
  "v6.anomalies.code.VALIDATION_ERROR": "Input refused: check the reason and the chosen fields.",
  "v6.anomalies.code.VERSION_CONFLICT": "The defect was modified meanwhile: reload it, then try again.",
  "v6.anomalies.code.WORKSPACE_ARCHIVED": "The project is archived: it is read-only.",
  "v6.anomalies.contexte.anomalie": "the defect",
  "v6.anomalies.contexte.aucun_environnement": "No environment declared in this project.",
  "v6.anomalies.contexte.aucune_version": "No version declared in this project.",
  "v6.anomalies.contexte.choisir": "Choose an environment or a version different from the current one.",
  "v6.anomalies.contexte.correction": "{{champ}}: {{avant}} → {{apres}} — “{{motif}}” ({{auteur}})",
  "v6.anomalies.contexte.corrections": "Kept corrections",
  "v6.anomalies.contexte.echec": "Saving the context did not succeed.",
  "v6.anomalies.contexte.enregistre": "Context saved; the corrections are kept.",
  "v6.anomalies.contexte.enregistrer": "Save the context",
  "v6.anomalies.contexte.environnement": "Environment",
  "v6.anomalies.contexte.environnements": "the project environments",
  "v6.anomalies.contexte.inchange": "— unchanged —",
  "v6.anomalies.contexte.manquantes": "Missing information: {{liste}}.",
  "v6.anomalies.contexte.motif": "Reason for the correction",
  "v6.anomalies.contexte.motif_aide": "Required, at least {{n}} characters: it is kept with the correction.",
  "v6.anomalies.contexte.motif_requis": "Write a reason of at least {{n}} characters.",
  "v6.anomalies.contexte.non_renseigne": "not provided",
  "v6.anomalies.contexte.reference": "Defect",
  "v6.anomalies.contexte.titre": "Complete a defect’s context",
  "v6.anomalies.contexte.version": "Version",
  "v6.anomalies.contexte.versions": "the project versions",
  "v6.anomalies.creer.attendu": "Expected result",
  "v6.anomalies.creer.cas": "Originating test case (optional)",
  "v6.anomalies.creer.cas_aide": "Number of the case in this project.",
  "v6.anomalies.creer.cas_invalide": "The originating case is a number.",
  "v6.anomalies.creer.champ_titre": "Title",
  "v6.anomalies.creer.choisir": "— choose —",
  "v6.anomalies.creer.cible": "Source target (optional)",
  "v6.anomalies.creer.cible_aide": "Targeted specification requirement, by its reference (for example EXG-12).",
  "v6.anomalies.creer.cree": "Defect {{reference}} reported.",
  "v6.anomalies.creer.declarer": "Report the defect",
  "v6.anomalies.creer.echec": "The report did not succeed; your input is kept.",
  "v6.anomalies.creer.environnement_inconnu": "Environment unknown, reported as such",
  "v6.anomalies.creer.environnement_requis": "Choose the environment, or report it unknown.",
  "v6.anomalies.creer.etapes": "Steps to reproduce",
  "v6.anomalies.creer.obtenu": "Actual result",
  "v6.anomalies.creer.preuve": "Evidence (optional)",
  "v6.anomalies.creer.preuve_aide": "Text, link or reference of an existing attachment.",
  "v6.anomalies.creer.priorite": "Priority",
  "v6.anomalies.creer.reproduction_requise": "Describe the steps, the expected and the actual result.",
  "v6.anomalies.creer.severite": "Severity",
  "v6.anomalies.creer.titre": "Report a defect",
  "v6.anomalies.creer.titre_requis": "Give a title.",
  "v6.anomalies.creer.version_inconnue": "Version unknown, reported as such",
  "v6.anomalies.creer.version_requise": "Choose the version, or report it unknown.",
  "v6.anomalies.doublons.aucun": "No possible duplicate found.",
  "v6.anomalies.doublons.aucune_fusion": "No automatic merge: you decide.",
  "v6.anomalies.doublons.candidat": "{{reference}} · {{titre}} ({{etat}}, similarity {{score}}%)",
  "v6.anomalies.doublons.ouvrir": "Open {{reference}}",
  "v6.anomalies.doublons.saisir": "Type a title to look for possible duplicates.",
  "v6.anomalies.doublons.titre": "Possible duplicates",
  "v6.anomalies.echec.aucun_cas": "No test case is permanently attached to it.",
  "v6.anomalies.echec.aucune_fermeture": "It is not closed by a verdict on the product.",
  "v6.anomalies.echec.cause": "Summarised cause",
  "v6.anomalies.echec.cause_absente": "No cause written by the verifier.",
  "v6.anomalies.echec.declare_le": "Observed on",
  "v6.anomalies.echec.deplier": "Show the full logs",
  "v6.anomalies.echec.echec": "the mission failure",
  "v6.anomalies.echec.etat": "State",
  "v6.anomalies.echec.journaux": "Mission logs",
  "v6.anomalies.echec.journaux_sans_mission": "No mission designated: logs unavailable.",
  "v6.anomalies.echec.journaux_vides": "The mission left no log.",
  "v6.anomalies.echec.mission": "mission {{mission}}",
  "v6.anomalies.echec.mission_inconnue": "mission not designated",
  "v6.anomalies.echec.non_compte": "A mission failure is not counted as a product defect.",
  "v6.anomalies.echec.origine": "Origin",
  "v6.anomalies.echec.pas_un_echec": "{{reference}} is a product defect, not a mission failure.",
  "v6.anomalies.echec.retour": "Back to defects",
  "v6.anomalies.echec.titre": "Mission failure",
  "v6.anomalies.echec.voir_mission": "View the mission",
  "v6.anomalies.etat.chargement": "Loading {{quoi}}…",
  "v6.anomalies.etat.en_cours": "In progress…",
  "v6.anomalies.etat.erreur": "{{quoi}}: the read did not succeed.",
  "v6.anomalies.etat.introuvable": "{{quoi}}: not found in this project.",
  "v6.anomalies.etat.reessayer": "Retry",
  "v6.anomalies.etat.refus": "{{quoi}}: access refused.",
  "v6.anomalies.etat_anomalie.aucune_transition": "No transition is possible from this state.",
  "v6.anomalies.etat_anomalie.canonique": "Canonical defect",
  "v6.anomalies.etat_anomalie.canonique_aide": "The defect this one duplicates; never itself.",
  "v6.anomalies.etat_anomalie.canonique_requise": "Choose the canonical defect.",
  "v6.anomalies.etat_anomalie.choisir": "Choose a transition.",
  "v6.anomalies.etat_anomalie.choisir_option": "— choose —",
  "v6.anomalies.etat_anomalie.classe": "Failure class",
  "v6.anomalies.etat_anomalie.classe_aide": "Required at triage: product, test, environment or flaky.",
  "v6.anomalies.etat_anomalie.classe_requise": "Choose the failure class.",
  "v6.anomalies.etat_anomalie.confirmer": "Confirm the transition",
  "v6.anomalies.etat_anomalie.correctif": "Fix reference",
  "v6.anomalies.etat_anomalie.correctif_aide": "SHA of the delivered commit (at least 7 characters) or identifier of the revision that contains it.",
  "v6.anomalies.etat_anomalie.correctif_requis": "Give the fix reference.",
  "v6.anomalies.etat_anomalie.courant": "{{reference}} · {{titre}} — current state: {{etat}}",
  "v6.anomalies.etat_anomalie.echec": "The transition did not succeed.",
  "v6.anomalies.etat_anomalie.fait": "Transition recorded: the defect is now “{{etat}}”.",
  "v6.anomalies.etat_anomalie.ineligible": "{{action}}: not possible — {{raison}}",
  "v6.anomalies.etat_anomalie.motif": "Reason",
  "v6.anomalies.etat_anomalie.motif_requis": "Write a reason of at least {{n}} characters.",
  "v6.anomalies.etat_anomalie.option_refusee": "{{action}} (not possible, see the reason)",
  "v6.anomalies.etat_anomalie.titre": "Change a defect’s state",
  "v6.anomalies.etat_anomalie.transition": "Transition",
  "v6.anomalies.qualite.actualiser": "Retry",
  "v6.anomalies.qualite.anciennes": "Oldest not closed",
  "v6.anomalies.qualite.anciennes_vide": "No open defect.",
  "v6.anomalies.qualite.aucune_exclusion": "No defect excluded.",
  "v6.anomalies.qualite.aucune_ouverte": "no open defect",
  "v6.anomalies.qualite.col_anciennete": "Age",
  "v6.anomalies.qualite.col_anomalie": "Defect",
  "v6.anomalies.qualite.col_etat": "State and severity",
  "v6.anomalies.qualite.col_version": "Version",
  "v6.anomalies.qualite.comptees": "Defects counted",
  "v6.anomalies.qualite.couverture": "View coverage",
  "v6.anomalies.qualite.definitions": "What the indicators say",
  "v6.anomalies.qualite.echappement": "Defects found in production",
  "v6.anomalies.qualite.exclusions": "Defects excluded from computations",
  "v6.anomalies.qualite.indicateurs": "the quality indicators",
  "v6.anomalies.qualite.insuffisant": "Insufficient data",
  "v6.anomalies.qualite.jours": "last {{n}} days",
  "v6.anomalies.qualite.lecon": "Lesson no. {{id}} ({{statut}}) — drawn from {{anomalie}}: {{symptome}}",
  "v6.anomalies.qualite.lecons": "Lessons",
  "v6.anomalies.qualite.lecons_vide": "No lesson in this project.",
  "v6.anomalies.qualite.mttr": "Mean time to fix",
  "v6.anomalies.qualite.mttr_detail": "over {{n}} closed defect(s)",
  "v6.anomalies.qualite.ouvertes": "Open",
  "v6.anomalies.qualite.perimetre": "Product defects only, over {{jours}} days, {{version}}; computed on {{date}}.",
  "v6.anomalies.qualite.periode": "Period",
  "v6.anomalies.qualite.premiere_fermeture": "The mean time to fix will appear after the first defect closed over the period.",
  "v6.anomalies.qualite.relire_lecon": "Review lesson no. {{id}}",
  "v6.anomalies.qualite.reouverture": "Reopenings",
  "v6.anomalies.qualite.sans_environnement": "{{n}} defect(s) without environment: where they were found is unknown.",
  "v6.anomalies.qualite.sans_version": "{{n}} defect(s) without version: they are attached to no version.",
  "v6.anomalies.qualite.sans_version_court": "no version",
  "v6.anomalies.qualite.statut_lecon.dismissed": "dismissed",
  "v6.anomalies.qualite.statut_lecon.proposed": "proposed",
  "v6.anomalies.qualite.statut_lecon.validated": "validated",
  "v6.anomalies.qualite.titre": "Quality dashboard",
  "v6.anomalies.qualite.toutes": "All",
  "v6.anomalies.qualite.toutes_versions": "all versions",
  "v6.anomalies.qualite.version": "Version",
  "v6.anomalies.qualite.vide": "No defect in this project: no indicator to compute.",
  "v6.anomalies.qualite.voir_exclues": "View excluded defects",
  "v6.anomalies.relire": "Reload the defect",
  "v6.anomalies.sans_projet": "Choose a project first.",
  "v6.anomalies.vague_ulterieure": "“{{ecran}}” leads to a screen that is not built yet: it comes with wave V4.",
  "v6.anomalies.voir_fiche": "View the defect record"
}
